const COLORS_SERIES = { G: "#f7931d", W: "#262261", U: "#79a26d" };

export { COLORS_SERIES };
